import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MenuItemService } from "@services/menuItem.service";
import { AdminMenuItem } from "@interfaces/adminMenuItem.interface";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "menu",
	styleUrls: ["menu.css"],
	templateUrl: "menu.html"
})
export class MenuAdminComponent {


	private allTiles: any[] = [];     // original full list
	filteredTiles: any[] = [];
	searchTerm = "";    // list after filtering
	tiles: AdminMenuItem[] = [];
	tilesGrouped: any[][] = [];       // what the template currently uses
	title = "";

	constructor(private route: ActivatedRoute, private toastService: ToastService, private router: Router, private menuItemService: MenuItemService) {
		this.route.params
			.subscribe((params) => {

				this.getTiles(params.id);
			});
	}

	applyFilter(): void {
		const term = (this.searchTerm || "").trim().toLowerCase();

		if (!term) {
			this.filteredTiles = [...this.allTiles];
		} else {
			this.filteredTiles = this.allTiles.filter(t => {
				const text = (t.text || "").toLowerCase();
				const category = (t.category || "").toLowerCase();
				return text.includes(term) || category.includes(term);
			});
		}

		this.tilesGrouped = this.groupTiles(this.filteredTiles);
	}


	getTiles(slug: string) {
		const slugPascal = slug.replace(/(\w)(\w*)/g,
			function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
		this.title = slugPascal + " Menu";
		this.menuItemService.getUserMenuItems(slug)
			.subscribe(
				(res: any) => {
					this.tiles = res.response;
					this.tiles.sort((a, b) => a.text.localeCompare(b.text));
					this.tiles.sort(function (a, b) {
						if (a.category === b.category) {
							// Price is only important when cities are the same
							return a.text.localeCompare(b.text);
						}
						return a.category > b.category ? 1 : -1;
					});

					this.allTiles = [...this.tiles];
					this.filteredTiles = [...this.tiles];
					this.tilesGrouped = this.groupTiles(this.filteredTiles);
					// const groupTest = this.tiles.reduce(
					// 	(result: any, currentValue: any) => {
					// 		(result[currentValue["category"]] = result[currentValue["category"]] || []).push(currentValue);
					// 		return result;
					// 	}, {});
					// console.log("Test: " + test);
					// this.tilesGrouped = this.tiles.reduce(function (r, a) {
					// 	r[a.category] = r[a.category] || [];
					// 	r[a.category].push(a);
					// 	return r;
					// }, Object.create(null));

					// console.log("JUST BEFORE: " + JSON.stringify(this.tilesGrouped));
					// this.tilesGrouped = Object.keys(groupTest).map((e: any) => {
					// 	console.log(groupTest[e]);
					// 	return groupTest[e];
					// });
				},
				(err) => console.log(err)
			);
	}

	private groupTiles(tiles: any[]): any[][] {
		// --- Use your existing grouping approach here ---
		// Example generic grouping by category:

		const grouped: { [key: string]: any[] } = {};

		for (const tile of tiles) {
			const cat = tile.category || "Other";
			if (!grouped[cat]) grouped[cat] = [];
			grouped[cat].push(tile);
		}

		// Keep category order stable relative to original list
		const orderedCats = Array.from(new Set(tiles.map(t => t.category || "Other")));

		return orderedCats.map(cat => grouped[cat]).filter(g => g && g.length);
	}




	navigate(route: string) {
		this.router.navigate([`admin/${route}`]);
	}
}